<template>
    <div class="">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Storages</li>
            </ol>
            <h4 class="main-title mb-2">Storages</h4>
        </div>
        <div class="row">
            <div class="col-4" v-can="'storages.create'">
                <form @submit.prevent="submitForm()">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">New Storage</h6>
                            <h6 class="card-title" v-else>Update Storage</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-12">
                                    <label class="form-label">Storage Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Storage Code" :class="{ 'is-invalid': errors.storage_code }" class="form-control" v-model="storage.storage_code" ref="storage_code" />
                                    <span v-if="errors.storage_code"><small class="text-danger">{{ errors.storage_code[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Storage Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Storage Name" :class="{ 'is-invalid': errors.storage_name }" class="form-control" v-model="storage.storage_name" />
                                    <span v-if="errors.storage_name"><small class="text-danger">{{ errors.storage_name[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                            <button type="submit" class="btn btn-primary" >
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div :class="column">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Storages</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()"/>
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm table-striped text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('storage_code')">
                                            Storage Code
                                            <span>
                                                <i v-if="meta.keyword=='storage_code' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='storage_code' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('storage_name')">
                                            Storage Name
                                            <span>
                                                <i v-if="meta.keyword=='storage_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='storage_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th class="text-center" v-can="'storages.delete'">Status</th>
                                        <th class="text-center" v-can="'storages.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="storages.length==0">
                                        <td colspan="5" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="storage, key in storages" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ storage.storage_code }}</td>
                                        <td>{{ storage.storage_name }}</td>
                                        <td class="text-center" v-can="'storages.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'storage' + storage.storage_id" :checked="storage.status" :value="storage.status" @change="deleteStorage(storage)" />
                                                <label class="custom-control-label" :for="'storage' + storage.storage_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-can="'storages.update'">
                                            <a href="javascript:void(0)" v-if="storage.status" class="text-success me-2" @click="editStorage(storage)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                column:'',
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "storage_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                storage: {
                    storage_id: "",
                    storage_code: "",
                    storage_name: "",
                },
                status: true,
                storages: [],
                errors: [],
            };
        },
        mounted() {
            this.create_storage = this.$store.getters.permissions.filter(function(element){
                return element.ability.ability.includes('storages.create')
            })
            if(this.create_storage.length){
                this.column = 'col-8'
            }else{
                this.column = 'col-12'
            }
            this.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addStorage();
                } else {
                    vm.updateStorage();
                }
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateStorages", data: vm.meta })
                    .then((response) => {
                        vm.storages = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            addStorage() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addStorage", data: vm.storage })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Storage Added successfully");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateStorage() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateStorage", data: vm.storage })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Storage is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            editStorage(storage) {
                let vm = this;
                vm.$refs.storage_code.focus();
                vm.errors = [];
                vm.status = false;
                vm.storage = storage;
            },

            deleteStorage(storage) {
                let vm = this;
                let loader = vm.$loading.show();
                storage.status = storage.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "deleteStorage", data: storage })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            discard() {
                let vm = this;
                vm.storage.storage_code = "";
                vm.storage.storage_name = "";
                vm.$refs.storage_code.focus();
                vm.errors = [];
                vm.status = true;
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
